import Drinks from "./Drinks";

export default Drinks;
